import { toast } from "react-hot-toast";
import { actionType } from "../utils/helpers/generalHelper";
import * as CareerConstants from "../constants/career.constant";
import CareerService from "../services/career.service";
import ErrorHelper from "../utils/helpers/errorHelper";

export const createNewJob = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(CareerConstants.CREATE_JOB_REQUEST));
    const data = await CareerService.createJob(payload);
    if (data === undefined || data.status !== 201) {
      throw data;
    }
    dispatch(actionType(CareerConstants.CREATE_JOB_SUCCESS, data.data));
    dispatch(fetchJobs());
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CareerConstants.CREATE_JOB_FAILURE));
    toast.error(message);
  }
};

export const fetchJobs = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(CareerConstants.FETCH_ALL_JOB_REQUEST));
    const data = await CareerService.fetchAllJobs(payload);
    console.log({ data });
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CareerConstants.FETCH_ALL_JOB_SUCCESS, data.data));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CareerConstants.FETCH_ALL_JOB_FAILURE));
    toast.error(message);
  }
};

export const createNewScholarship = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(CareerConstants.CREATE_SCHOLARSHIP_REQUEST));
    const data = await CareerService.createScholarship(payload);
    if (data === undefined || data.status !== 201) {
      throw data;
    }
    dispatch(actionType(CareerConstants.CREATE_SCHOLARSHIP_SUCCESS, data.data));
    dispatch(fetchScholarships());
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CareerConstants.CREATE_SCHOLARSHIP_FAILURE));
    toast.error(message);
  }
};

export const fetchScholarships = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(CareerConstants.FETCH_ALL_SCHOLARSHIP_REQUEST));
    const data = await CareerService.fetchAllScholarships(payload);
    console.log({ data });
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CareerConstants.FETCH_ALL_SCHOLARSHIP_SUCCESS, data.data)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CareerConstants.FETCH_ALL_SCHOLARSHIP_FAILURE));
    toast.error(message);
  }
};

export const deleteJob = (payload) => async (dispatch) => {
  const { id, action } = payload;
  try {
    dispatch(
      actionType(CareerConstants.DELETE_JOB_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await CareerService.deleteAJob(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CareerConstants.DELETE_JOB_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Job ${action}d successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(
      actionType(CareerConstants.DELETE_JOB_FAILURE, {
        loading: false,
        id,
      })
    );
    toast.error(message);
  }
};

export const deleteAScholarship = (payload) => async (dispatch) => {
  const { id, action } = payload;
  try {
    dispatch(
      actionType(CareerConstants.DELETE_SCHOLARSHIP_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await CareerService.deleteScholarship(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CareerConstants.DELETE_SCHOLARSHIP_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Scholarship ${action}d successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(
      actionType(CareerConstants.DELETE_SCHOLARSHIP_FAILURE, {
        loading: false,
        id,
      })
    );
    toast.error(message);
  }
};
